import {
  IoChatbubbleEllipses,
  IoCodeSlash,
  IoGameController,
  IoInformationCircle,
} from "react-icons/io5";
import { IconBaseProps } from "react-icons/lib/cjs/iconBase";
import styled from "styled-components";

type Icon = (props: IconBaseProps) => JSX.Element;

const MiddleIcon = (component: Icon) => styled(component)`
  vertical-align: text-top;
  padding-right: 0.25em;
  padding-top: 0.05em;
`;

export const GamingIcon = MiddleIcon(IoGameController);
export const ProgrammingIcon = MiddleIcon(IoCodeSlash);
export const RamblingsIcon = MiddleIcon(IoChatbubbleEllipses);
export const MetaIcon = MiddleIcon(IoInformationCircle);

export default MiddleIcon;
